<ion-grid class="info-msg-grid" *ngIf="shouldShowMessage()">
  <ion-row>
    <ion-col class="info-message-banner">
      <ion-button [attr.id]="'info-msg-' + popupId" expand="block">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <p class="infobuttontext">{{ message.tittel }}</p>
        <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
      </ion-button>
    </ion-col>
    <ion-modal [trigger]="'info-msg-' + popupId" class="info-msg-modal-content">
      <ng-template>
        <div class="modalClose">
          <img src="/assets/img/shared/close.svg" (click)="closeModal()" />
        </div>
        <ion-content class="info-message-ion-content">
          <div>
            <ion-icon name="alert-circle-outline" size="large"></ion-icon>
            <h2>
              {{ message.tittel }}
            </h2>
            <h3>
              {{ message.ingress }}
            </h3>
            <p>
              {{ message.melding }}
            </p>
          </div>
        </ion-content>
      </ng-template>
    </ion-modal>
  </ion-row>
</ion-grid>
